// Desktop adapter — a single interface the UI layer uses to talk to the
// host runtime. In Tauri builds the adapter forwards to Rust commands via
// `window.__TAURI__.core.invoke`. In browser builds it uses localStorage
// + fetch directly. Zero behavior change in Tauri mode.

import { getPlatform } from '../platform';
import { browserAdapter } from './browser';
import { tauriAdapter } from './tauri';

export interface EnterpriseConfig {
	serverUrl: string;
	wsUrl: string;
	token: string;
	version: string;
}

export interface DesktopAdapter {
	getEnterpriseConfig(): Promise<EnterpriseConfig | null>;
	setEnterpriseConfig(serverUrl: string, token: string): Promise<void>;
	exchangeAuthCode(serverUrl: string, code: string): Promise<{ token: string }>;
	switchAccount(): Promise<void>;
	showLauncher(): Promise<void>;
	/** PWA-only today: purge every stored enterprise config so a stale token
	 *  can't replay on the next load. Tauri should route account-reset through
	 *  its own session flow. */
	clearEnterpriseConfig?(): Promise<void>;
}

export function getAdapter(): DesktopAdapter {
	return getPlatform() === 'tauri' ? tauriAdapter : browserAdapter;
}
